import { APP_ID } from "../config/constants";
import { getRequest } from "../connection/network";

const categoriesAPI = "videoCategory";

export const listCategoriesService = async () => {
  try {
    const token = localStorage.getItem("token");
    const {
      data: {
        data,
        meta: { thisPage, allPages },
      },
    } = await getRequest({
      token,
      query: { appId: APP_ID },
      endPoint: categoriesAPI,
    });

    return {
      data,
      thisPage: parseInt(thisPage),
      allPages: parseInt(allPages),
    };
  } catch (error) {
    const sError =
      error?.response?.data?.error?.message || "Unkown error occured";
    return { error: sError };
  }
};
